const octopusVariablePattern = /^#\{.+\}$/;

const readRuntimeConfig = () => {
  if (typeof window === 'undefined' || !window.__RUNTIME_CONFIG__) {
    return {};
  }

  return window.__RUNTIME_CONFIG__;
};

const isResolvedValue = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 && !octopusVariablePattern.test(trimmedValue);
};

export const getRuntimeConfigValue = (key, fallbackValue) => {
  const runtimeConfig = readRuntimeConfig();
  const runtimeValue = runtimeConfig[key];

  if (isResolvedValue(runtimeValue)) {
    return runtimeValue;
  }

  return fallbackValue;
};
